import React, { useEffect, useMemo, useState } from "react";
import Container from "../components/Layout/Container";
import ContentBlock from "../components/Layout/ContentBlock";
import FilterMenu from "../components/Layout/FilterMenu";
import TableFilterBox from "../components/common/TableFilterBox";
import ContentValidation from "../components/common/ContentValidation";
import Pagination from "../components/Dashboard/items/Pagination";
import { getDateFormat, prettyDateFormat } from "../helpers/Utils";
import {
  ButtonSmall,
  CheckBoxInput,
  SelectForm,
} from "../components/common/Buttons";
import RangePickerComp from "../components/common/RangePickerComp";
import { Tooltip } from "antd";
import { IconDot, IconSearch } from "../components/Layout/Icons";
import { useDispatch, useSelector } from "react-redux";
import {
  exportToAlso,
  getAlsoIncomes,
  getAlsoIncomesOptions,
} from "../redux/Actions/also_incomes_action";
import ModalAlsoIncomeModule from "../components/AlsoIncomeModule/ModalAlsoIncomeModule";
import { DebounceSelect } from "../components/common";
import errorHandler from "../helpers/ErrorHandler";
import Axios from "axios";
import { handleKeyDown, onChangeUseState } from "../helpers/FunctionsGlobal";
import InputText from "../components/orders/accepted_orders/InputFilter";
import AlsoIncomesTabUi from "./AlsoIncomesTabUi";
import { Label } from "../components/globals";

const filterInitial = {
  date: ["", ""],
  status: undefined,
  user_id: undefined,
  close_date: ["", ""],
  earned: "",
  product: undefined,
  order_number: "",
  also_no: "",
  supplier_code: "",
  add_to: undefined,
};
export default function AlsoIncomeModuleScreen({
  match,
  history,
  tabId,
  setTabId,
}) {
  console.log("AlsoIncomeModuleScreen");
  const dispatch = useDispatch();

  const { totals, current, loading, data, options, show_data } = useSelector(
    (state) => state.custom
  );
  const role_identifier = useSelector((state) => state.auth.user.role);

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(50);
  const [filters, setFilters] = useState(filterInitial);
  const [filterString, setfilterString] = useState("&q[status_eq]=pending");
  const [selected, setSelected] = useState([]);

  const [modalPreview, setModalPreview] = useState(false);

  useEffect(() => {
    console.log("2");
    dispatch(getAlsoIncomes(page, perPage, filterString));
  }, [filterString, page, perPage]);
  useEffect(() => {
    dispatch(getAlsoIncomesOptions());
  }, []);
  console.log({ options });

  // useEffect(() => {
  //   onFilter();
  // }, [
  //   filters.date,
  //   filters.status,
  //   filters.user_id,
  //   filters.close_date,
  //   filters.earned,
  // ]);

  const onFilter = () => {
    let filterParams = "";
    filterParams += `&q[status_eq]=pending`;
    if (filters.date.every((d) => d)) {
      filterParams += `&q[created_at_gteq]=${filters.date[0]}`;
      filterParams += `&q[created_at_lteq]=${filters.date[1]}`;
    }
    if (filters.status) filterParams += `&q[status_eq]=${filters.status}`;
    if (filters.user_id) filterParams += `&q[user_id_eq]=${filters.user_id}`;
    if (filters.close_date.every((d) => d)) {
      filterParams += `&q[close_date_gteq]=${filters.close_date[0]}`;
      filterParams += `&q[close_date_lteq]=${filters.close_date[1]}`;
    }
    // ???
    if (filters.earned) filterParams += `&q[earned_eq]=${filters.earned}`;
    if (filters.add_to) filterParams += `&q[add_to_eq]=${filters.add_to}`;
    if (filters.order_number)
      filterParams += `&q[order_nr_cont_any]=${filters.order_number}`;
    if (filters.also_no)
      filterParams += `&q[also_no_cont_any]=${filters.also_no}`;
    if (filters.supplier_code)
      filterParams += `&q[supplier_code_or_supplier_name_cont_any]=${filters.supplier_code}`;
    if (filters.product)
      filterParams += `&q[also_income_item_sku_or_also_income_item_product_title_cont_any]=${filters.product}`;
    console.log(filterParams);

    setfilterString(filterParams);
    setPage(1);
  };
  const renderCustomButton = () => {
    return (
      <>
        <button
          type="button"
          className="btn btn-sm btn-primary float-left ml-3"
          onClick={() => setModalPreview(0)}
        >
          {"New document"}
        </button>
        {"accounting" == role_identifier && (
          <div className="dropdown">
            <button
              className="btn btn-sm btn-dark float-right mr-3"
              onClick={() => exportToAlso(selected)}
            >
              Export
            </button>
          </div>
        )}
      </>
    );
  };

  const fetchOptions = async (value) => {
    try {
      let api_url = `/api/v1/also_incomes/simple_products?q[sku_or_product_title_i_cont_any]=${value}`;

      const { data } = await Axios.get(api_url);
      console.log({ data });
      const valArr = data?.data?.filter((d) => d.sku) || [];
      return (
        [
          {
            label: "No data selected",
            value: "",
          },
          ...valArr.map((e) => {
            return {
              ...e,
              value: e.sku,
              label: `${e.sku} - ${e.product_title}`,
            };
          }),
        ] || []
      );
    } catch (err) {
      errorHandler(err);
      return [];
    }
  };

  console.log({ perPage, page });

  return (
    <Container
      location={{
        locationName: "3PL incomes",
        locationUrl: "match.url",
      }}
    >
      <ContentBlock>
        <FilterMenu
          totals={totals}
          length={data.length}
          noLowerCase={true}
          text2="3PL incomes"
          onChangeCountPage={setPerPage}
          countPage={perPage}
        />
      </ContentBlock>
      <div style={{ marginLeft: 15 }}>
        <AlsoIncomesTabUi
          tabId={tabId}
          setTabId={setTabId}
          counts={{
            all_documents: show_data.total_all,
            require_review: show_data.total_require_review,
            pending: show_data.total_pending,
          }}
        />
      </div>
      <ContentBlock containerClass="py-1">
        <TableFilterBox
          filter={true}
          onFilter={() => onFilter()}
          clearFilter={() => setFilters(filterInitial)}
          button1={renderCustomButton()}
        >
          <div className="px-1">
            <InputText
              name="order_number"
              placeholder="Order No."
              style={{ width: 165, fontSize: "0.75rem" }}
              value={filters.order_number}
              onKeyDown={(e) => handleKeyDown(e, onFilter)}
              onChange={onChangeUseState(setFilters)}
            />
          </div>
          <div className="px-1">
            <div className="form-group order-input-form-group">
              <Label className="text-sm-label">Date</Label>
              <RangePickerComp
                placeholder={["Start time", "End time"]}
                value={[
                  getDateFormat(filters.date[0]),
                  getDateFormat(filters.date[1]),
                ]}
                onChange={(_, date) =>
                  setFilters((prev) => ({ ...prev, date }))
                }
              />
            </div>
          </div>

          <div className="px-1">
            <DebounceSelect
              label="Product title or sku"
              showSearch={true}
              value={filters.product || undefined}
              placeholder={"Enter"}
              fetchOptions={fetchOptions}
              onChange={(val) => {
                setFilters((prev) => ({
                  ...prev,
                  product: val.value,
                }));
              }}
              style={{
                width: "165px",
              }}
            />
          </div>
          <div className="px-1">
            <InputText
              name="supplier_code"
              placeholder="Supplier code"
              style={{ width: 165, fontSize: "0.75rem" }}
              value={filters.supplier_code}
              onKeyDown={(e) => handleKeyDown(e, onFilter)}
              onChange={onChangeUseState(setFilters)}
            />
          </div>
          <div className="px-1">
            <SelectForm
              placeholder="Manager"
              dropdownMatchSelectWidth={false}
              options={
                options?.managers
                  ? [
                      {
                        label: "All",
                        value: "",
                      },
                      ...options?.managers,
                    ]
                  : []
              }
              onChange={(user_id) =>
                setFilters((prev) => ({ ...prev, user_id }))
              }
              style={{ width: 165 }}
              value={filters.user_id}
            />
          </div>
          <div className="px-1">
            <SelectForm
              placeholder="Warehouse"
              dropdownMatchSelectWidth={false}
              options={[
                {
                  value: "ALSO",
                  label: "ALSO",
                },
                {
                  value: "ADREM",
                  label: "ADREM",
                },
                {
                  value: "OFFICE",
                  label: "OFFICE",
                },
              ]}
              onChange={(add_to) => setFilters((prev) => ({ ...prev, add_to }))}
              style={{ width: 165 }}
              value={filters.add_to}
            />
          </div>
          <div className="px-1">
            <InputText
              name="also_no"
              placeholder="PO No."
              style={{ width: 165, fontSize: "0.75rem" }}
              value={filters.also_no}
              onKeyDown={(e) => handleKeyDown(e, onFilter)}
              onChange={onChangeUseState(setFilters)}
            />
          </div>
        </TableFilterBox>
        <div>
          <ContentValidation loader={loading} array={data}>
            <div className="table-responsive" style={{ overflow: "hidden" }}>
              <table className="table mt-3 line-height-normal">
                <thead>
                  <tr className="text-muted">
                    <th className="text-black">
                      <CheckBoxInput
                        checked={
                          selected.length ==
                          data?.filter((d) => !d.in_progress_at).length
                        }
                        onChange={() => {
                          if (
                            selected.length ==
                            data?.filter((d) => !d.in_progress_at).length
                          ) {
                            setSelected([]);
                          } else {
                            setSelected(
                              data
                                ?.filter((d) => !d.in_progress_at)
                                .map((d) => d.id) || []
                            );
                          }
                        }}
                      />
                    </th>
                    <th className="text-black">Document No.</th>
                    <th className="text-black">Creation date</th>
                    <th className="text-black">Supplier code</th>
                    <th className="text-black">Order No.</th>
                    <th className="text-black">Manager</th>
                    <th className="text-black">PO No.</th>
                    <th className="text-black">Pending till</th>
                    <th className="text-black">Arrival date</th>
                    <th className="text-black">Warehouse</th>
                    <th className="text-black">Total/Used qty</th>
                    <th className="text-black"></th>
                  </tr>
                </thead>
                <tbody>
                  {!loading &&
                    current == "AlsoIncomes" &&
                    data.map((item, idx) => {
                      return (
                        <AlsoIncomeItem
                          key={item.id}
                          idx={idx}
                          history={history}
                          selected={selected.includes(item.id)}
                          setSelected={() =>
                            setSelected((prev) => {
                              let obj = [...prev];
                              if (obj.includes(item.id)) {
                                return obj.filter((value) => value !== item.id);
                              } else {
                                return [...obj, item.id];
                              }
                            })
                          }
                          {...item}
                        />
                      );
                    })}
                </tbody>
              </table>
              <Pagination
                page={page}
                pageCount={perPage}
                totals={totals}
                setPagination={setPage}
              />
            </div>
          </ContentValidation>
        </div>
      </ContentBlock>

      {typeof modalPreview == "number" && (
        <ModalAlsoIncomeModule
          id={modalPreview}
          modalFunc={setModalPreview}
          history={history}
        />
      )}
    </Container>
  );
}

const AlsoIncomeItem = ({
  id,
  status,
  user_full,
  created_at,
  also_no,
  add_to,
  document_no,
  history,
  selected,
  setSelected,
  review_at,
  arrival_date,
  order_nr,
  order_date,
  supplier_code,
  in_progress_at,
  qty,
  used_qty,
  api_errors,
  canceled_at,
}) => {
  const status_color = useMemo(() => {
    let color = "#CBCBCB";
    let text =
      typeof status == "string"
        ? `${status.charAt(0).toUpperCase()}${status
            .toLowerCase()
            .slice(1)
            .split("_")
            .join(" ")}`
        : "-";
    // let text = "Dar nenusiųsta pajamavimui";
    if (status == "completed") {
      color = "#ADCB35";
      // text = "Pilnai supajamuota";
    } else if (status == "in_progress") {
      color = "#FFCC69";
      // text = "Pradėta pajamuota";
    } else if (status == "failed") {
      color = "#FF0000";
      text = api_errors || "";
    } else if (status == "canceled") {
      color = "#742a40";
      text = `Canceled at: ${
        canceled_at ? prettyDateFormat(canceled_at) : "None"
      }`;
    }
    return {
      color,
      text,
    };
  }, [status]);
  return (
    <tr className="align-middle tableColumn">
      <td className="align-middle">
        {" "}
        <CheckBoxInput
          disabled={in_progress_at}
          checked={selected}
          onChange={() => setSelected()}
        />
      </td>
      <td className="align-middle">{document_no}</td>
      <td className="align-middle">{prettyDateFormat(created_at)}</td>
      <td className="align-middle">{supplier_code}</td>
      <td className="align-middle">
        <div>
          {order_nr && <div>No: {order_nr}</div>}
          {order_date && <div className="text-xs">Date: {order_date}</div>}
        </div>
      </td>
      <td className="align-middle">{user_full}</td>
      <td className="align-middle">{also_no}</td>
      <td className="align-middle">{review_at}</td>
      <td className="align-middle">{arrival_date}</td>
      <td className="align-middle">{add_to}</td>
      <td className="align-middle">
        {qty}/{used_qty}
      </td>
      <td className="align-middle d-flex justify-content-end">
        <ButtonSmall
          className={"ml-2"}
          onClick={() => history.push(`/also_income_module/${id}`)}
        >
          <IconSearch color="#fff" />
        </ButtonSmall>
      </td>
    </tr>
  );
};
